import { Component, Input, OnInit } from '@angular/core';

import { ScreenTalentService } from '../../../screen-talent.service';
import { AuthService } from '../../../../../../providers/auth.service';


export class LibraryComponent implements OnInit {

	 public hackId: string;
	 public test: any;
	 public visibility: string = 'public';

	public type: string = 'knowledge';

	constructor(
		private authService: AuthService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit() {
		if (this.test.type === 'remote-interview') {
			this.type = 'coding';
		}
	}

	// Events
	public onLibraryTypeChange(type: string) {
		this.type = type;
	}

	public onBackClick(): void {
		this.screenTalentService.emitEventAction({ component: 'summary', action: 'changeView', data: 'list' });
	}
	// Service Call

	// Helpers
static ctorParameters() { return [ { type: AuthService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/library/library.component.ts